import React from 'react';
import Icon from 'components/AppIcon';

const LoadingSpinner = () => {
  return (
    <div className="flex items-center justify-center py-16">
      <div className="text-center">
        <div className="animate-spin mb-4 mx-auto">
          <Icon name="Loader2" size={32} className="text-primary" />
        </div>
        <p className="text-muted-foreground">Loading gallery...</p>
      </div>
    </div>
  );
};

export default LoadingSpinner;